/* eslint-disable prettier/prettier */
import React from 'react'
import { CInputGroup, CFormInput, CButton } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilReload } from '@coreui/icons'
import PropTypes from 'prop-types'

export const generateMathCaptcha = () => {
    const operations = ['+', '-', '*', '/'];

    const getRandomNumber = () => Math.floor(Math.random() * 90) + 10; // 10–99

    let num1 = getRandomNumber();
    let num2 = getRandomNumber();
    let op = operations[Math.floor(Math.random() * operations.length)];
    let expression = '';
    let answer = 0;

    if (op === '+') {
        expression = `${num1} + ${num2}`;
        answer = num1 + num2;
    } else if (op === '-') {
        if (num1 < num2) [num1, num2] = [num2, num1]; // Ensure positive result
        expression = `${num1} - ${num2}`;
        answer = num1 - num2;
    } else if (op === '*') {
        expression = `${num1} * ${num2}`;
        answer = num1 * num2;
    } else if (op === '/') {
        // Force clean division
        num2 = Math.floor(Math.random() * 9) + 1; // 1-9 divisor
        answer = Math.floor(Math.random() * 10 + 1); // small quotient
        num1 = num2 * answer;
        expression = `${num1} / ${num2}`;
    }

    return {
        expression,
        answer,
    };
};

// Component
export const MathCaptcha = ({ captcha, userCaptcha, setUserCaptcha, refreshCaptcha }) => {
    return (
        <div className="mb-3 text-center">
            <CInputGroup className="d-flex align-items-center justify-content-center">
                <span className="me-2 fs-5 fw-bold">{captcha.expression} =</span>
                <CFormInput
                    type="text"
                    id="captcha"
                    placeholder="Enter the result"
                    value={userCaptcha}
                    onChange={(e) => setUserCaptcha(e.target.value)}
                    required
                    className="w-25 text-center"
                />
                <CButton color="secondary" className="ms-2" onClick={refreshCaptcha}>
                    <CIcon icon={cilReload} />
                </CButton>
            </CInputGroup>
        </div>
    )
}

// PropTypes
MathCaptcha.propTypes = {
    captcha: PropTypes.shape({
        expression: PropTypes.string.isRequired,
        answer: PropTypes.number.isRequired,
    }).isRequired,
    userCaptcha: PropTypes.string.isRequired,
    setUserCaptcha: PropTypes.func.isRequired,
    refreshCaptcha: PropTypes.func.isRequired,
}
